import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import type { ChatMessage } from '../hooks/useMusicIqChatbot';
import { MessageBubble } from './MessageBubble';

interface MessageListProps {
  messages: ChatMessage[];
  isThinking: boolean;
}

// @TODO WMG1-908 - Revisit this and refactor if necessary.
export function MessageList({ messages, isThinking }: MessageListProps) {
  const { t } = useTranslation('data');
  const bottomRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive or thinking state changes
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isThinking]);

  return (
    <div className="flex flex-1 flex-col gap-md overflow-y-auto p-lg">
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
      {isThinking ? (
        <div className="text-body-sm italic text-subtle">
          {t('musicIq.chatbot.thinking')}
        </div>
      ) : null}
      <div ref={bottomRef} />
    </div>
  );
}

MessageList.displayName = 'MessageList';
